<div class="ostso-dialog landmark">
  <div class="header">
    <h1>{{ isNew ? "Создание группы учреждений" : "Редактирование группы учреждений" }}</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Группа учреждений">

      <input class="remarktype-textarea" matInput [formControlName]="'shortName'" placeholder="Краткое наименование">

      <pas-multi-select3 [formControlName]="'indicator'"
                         title="Показатель"
                         [customDataService]="indicatorService"
                         [options]="{pageSize: 1e6}"
                         customDialogMethod="apiIndicatorGet"
      >
        <ng-template #listItem let-item>
          {{ item.name }} ({{ item?.shortName }}), (ID: {{ item?.id }}), ({{item?.period?.name}})
        </ng-template>
        <ng-template #dialogList let-item>
          {{ item?.name }} ({{ item?.shortName }}), (ID: {{ item?.id }}), ({{item?.period?.name}})
        </ng-template>
      </pas-multi-select3>

      <label for="object">
        <input id="object" type="checkbox" [formControlName]="'object'">
        Объекты
      </label>

    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="!form.valid" >Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

